import { Select } from "antd";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { patchRequest } from "../../axios";
import { SuccessNotificationMsg } from "../../utils/Notifications";
import { useTranslation } from "react-i18next";
import { confirmAlert } from "react-confirm-alert";
import { authUserData } from "../../utils/Helper";
import { useNavigate } from "react-router-dom";

const AssignRFQVendor = ({
  assignToBuyer,
  assignBuyer,
  rfqDetails,
  assignPurchaseRequisitionDetails,
  onBuyerChange, 
}) => {
  const [tempBuyer, setTempBuyer] = useState(assignToBuyer || null); 
  
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const { t } = useTranslation();
  const companyUserName = authUserData()?.company
    ? authUserData()?.first_name
    : null;

  const companyUserId = authUserData()?.vendor ? authUserData()?.user_id : null;

  const navigate = useNavigate();

  const toCapitalCase = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  useEffect(() => {
    if (assignToBuyer) {
      setTempBuyer(toCapitalCase(assignToBuyer));
    }
  }, [assignToBuyer]);

  const saveAssignToBuyer = async (
    hasBeenAssigned,
    value,
    RecordId,
    prevId,
    previoID
  ) => {
    let payload;
    if (hasBeenAssigned) {
      payload = {
        id: previoID,
        rfq_assign_sales_manager: value,
      };
    } else {
      payload = {
        rfq_assign_sales_manager: value,
      };
    }

    try {
      const response = await patchRequest(
        `float-rfq/${RecordId}/vendor-assign-to-sales-manager/`,
        payload
      );

      // Extract the success message from the response
      const successMessage = response.data.message;

      if (successMessage) {
        SuccessNotificationMsg(successMessage);
        navigate("/rfq-vendor-request-for-quotation/history/1")
        setReload(!reload)
      } else {
        // If there's no success message in the response, use a default one
        //console.error("Error updating assignee:", error);
      }

      // Optionally, you can perform other actions after success, such as reloading data or updating state
      setReload(!reload);
      setLoading(false);
    } catch (error) {
      console.error("Error updating assignee:", error);
      // Optionally, handle error condition here, such as displaying an error message
    }
  };


  //   const handleSelectBuyerChange = (value) => {
  //     console.log('value44 ', value);

  //     setTempBuyer(value);

  //     confirmAlert({
  //       title: "Confirm",
  //       message:
  //         "Are you sure you want to assign the selected employee to assign PR?",
  //       buttons: [
  //         {
  //           label: "Yes",
  //           onClick: () => {
  //             saveAssignToBuyer(value, assignPurchaseRequisitionDetails.id);
  //           },
  //         },
  //         {
  //           label: "No",
  //           onClick: () => {
  //             setTempBuyer(assignToBuyer); // Reset the buyer to original if canceled
  //           },
  //         },
  //       ],
  //     });
  //   };
  const me = tempBuyer === companyUserId ? companyUserId : tempBuyer;
// Parse due date-time once before return/render
const dueDateStr = rfqDetails.rfq_due_date; // e.g. "23-05-25 09:00"
let disableDueDate = false;

if (dueDateStr) {
  const [datePart, timePart] = dueDateStr.split(" ");
  const [yy, mm, dd] = datePart.split("-").map(Number);
  const [hh, min] = timePart.split(":").map(Number);

  const fullYear = 2000 + yy;
  const dueDate = new Date(fullYear, mm - 1, dd, hh, min);

  disableDueDate = dueDate < new Date();
}

  const handleAssignToBuyerChange = async (value, record) => {
    console.log("value77 ", value, "record", record);
  
    // Checking if the assignment is to "me"
    if (value === "me") {
      const hasBeenAssigned = record.rfq_vendor_assign_sales_manager_id !== null;
  
      confirmAlert({
        title: (
          <div style={{ fontSize: "20px", fontWeight: "bold", color: "#094e8f", textAlign: "center" }}>
            Confirm
          </div>
        ),
        message: (
          <div style={{ fontSize: "16px", color: "#333", textAlign: "center" }}>
            {hasBeenAssigned
              ? `Are you sure you want to Reassign to me for BID RFQ?`
              : `Are you sure you want to Assign to me for BID RFQ?`}
          </div>
        ),
        buttons: [
          {
            label: "Yes",
            onClick: () =>
              saveAssignToBuyer(
                hasBeenAssigned,
                companyUserId,
                record.id,
                record.rfq_vendor_assign_sales_manager_id,
                record.rfq_vendor_assign_sales_id
              ),
            style: {
              backgroundColor: "#094e8f",
              color: "#fff",
              border: "none",
              padding: "12px 20px",
              fontSize: "16px",
              borderRadius: "5px",
              margin: "10px",
              cursor: "pointer",
            },
          },
          {
            label: "No",
            onClick: () => {
              // Optional: handle cancellation
            },
            style: {
              backgroundColor: "#f1f1f1",
              color: "#000",
              border: "none",
              padding: "12px 20px",
              fontSize: "16px",
              borderRadius: "5px",
              margin: "10px",
              cursor: "pointer",
            },
          },
          {
            label: "Assign & BID",
            onClick: async () => {
              await saveAssignToBuyer(
                hasBeenAssigned,
                companyUserId,
                record.id,
                record.rfq_vendor_assign_sales_manager_id,
                record.rfq_vendor_assign_sales_id
              );
              navigate(`/rfq-vendor-request-for-quotation-city-wise/bid-rfq/${btoa(record.id)}`);
            },
            style: {
              backgroundColor: "#4caf50",
              color: "#fff",
              border: "none",
              padding: "12px 20px",
              fontSize: "16px",
              borderRadius: "5px",
              margin: "10px",
              cursor: "pointer",
            },
          },
        ],
        overlayStyle: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
        titleStyle: {
          color: "#094e8f",
          fontSize: "24px",
          fontWeight: "bold",
          textAlign: "center",
        },
        messageStyle: {
          color: "#333",
          fontSize: "16px",
          textAlign: "center",
        },
        className: "custom-modal-design", // Add your custom CSS class for extra styling
      });
    } else {
      const selectedEmployee = assignBuyer.find(
        (employee) => employee.id === value
      );
      const employeeName = selectedEmployee ? selectedEmployee.first_name : "";
      const hasBeenAssigned = record.rfq_vendor_assign_sales_manager_id !== null;
  
      confirmAlert({
        title: (
          <div style={{ fontSize: "20px", fontWeight: "bold", color: "#094e8f", textAlign: "center" }}>
            Confirm
          </div>
        ),
        message: (
          <div style={{ fontSize: "16px", color: "#333", textAlign: "center" }}>
            {hasBeenAssigned
              ? `Are you sure you want to Reassign ${employeeName} for BID RFQ?`
              : `Are you sure you want to Assign ${employeeName} for BID RFQ?`}
          </div>
        ),
        buttons: [
          {
            label: "Yes",
            onClick: () =>
              saveAssignToBuyer(
                hasBeenAssigned,
                value,
                record.id,
                record.rfq_vendor_assign_sales_manager_id,
                record.rfq_vendor_assign_sales_id
              ),
            style: {
              backgroundColor: "#094e8f",
              color: "#fff",
              border: "none",
              padding: "12px 20px",
              fontSize: "16px",
              borderRadius: "5px",
              margin: "10px",
              cursor: "pointer",
            },
          },
          {
            label: "No",
            onClick: () => {
              // Optional: handle cancellation
            },
            style: {
              backgroundColor: "#f1f1f1",
              color: "#000",
              border: "none",
              padding: "12px 20px",
              fontSize: "16px",
              borderRadius: "5px",
              margin: "10px",
              cursor: "pointer",
            },
          },
          {
            label: "Assign & BID",
            onClick: async () => {
              await saveAssignToBuyer(
                hasBeenAssigned,
                companyUserId,
                record.id,
                record.rfq_vendor_assign_sales_manager_id,
                record.rfq_vendor_assign_sales_id
              );
              navigate(`/rfq-vendor-request-for-quotation-city-wise/bid-rfq/${btoa(record.id)}`);
            },
            style: {
              backgroundColor: "#094e8f",
              color: "#fff",
              border: "none",
              padding: "12px 20px",
              fontSize: "16px",
              borderRadius: "5px",
              margin: "10px",
              cursor: "pointer",
            },
          },
        ],
        overlayStyle: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
        titleStyle: {
          color: "#094e8f",
          fontSize: "24px",
          fontWeight: "bold",
          textAlign: "center",
        },
        messageStyle: {
          color: "#333",
          fontSize: "16px",
          textAlign: "center",
        },
        className: "custom-modal-design", // Add your custom CSS class for extra styling
      });
    }
  };
  

  return (
    <Select
      className="cust-selectBox"
      showArrow
      showSearch
      allowClear = {false}
      // value={tempBuyer || "Unassigned"}
      defaultValue={tempBuyer}
      value={me ? me : "Unassigned"}
      onChange={(e) => handleAssignToBuyerChange(e, rfqDetails)}
      disabled={(rfqDetails.bid_rfq_by_vendor === true && rfqDetails.rfq_vendor_assign_sales_manager_id !== null) || disableDueDate}
    >
      <Select.Option key="01" value={companyUserId}>
        Assign to me
      </Select.Option>
      {assignBuyer.map((option) => (
        <Select.Option key={option.id} value={option.id}>
          {option.first_name}
        </Select.Option>
      ))}
    </Select>
  );
};

AssignRFQVendor.propTypes = {
  assignToBuyer: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Accept string or number
  assignBuyer: PropTypes.array.isRequired,
  rfqDetails: PropTypes.object,
  assignPurchaseRequisitionDetails: PropTypes.object.isRequired,
  onBuyerChange: PropTypes.func.isRequired, // New callback to update the buyer
};

export default AssignRFQVendor;
